module.exports = __webpack_public_path__ + "img/page.85d8bb3b.png";